module.exports = __webpack_public_path__ + "images/b6efea1411b5ad86f14a99d229e819f5.svg";